import { IPlan, ReferralDiscount } from '../components/Plans/Plans';

export type PlanPricing = {
  finalCents: number;
  originalCents?: number;
  hasReferralDiscount: boolean;
  discountPercent: number;
};

export const hasActiveReferralSubscription = (discount?: ReferralDiscount): boolean => {
  if (!discount || discount.discount_percent <= 0) return false;
  return discount.reason !== 'no_referral';
};

export const getPlanPricing = (plan: IPlan): PlanPricing => {
  const discount = plan.referral_discount;

  if (discount?.is_eligible && plan.price_in_cents > 0) {
    return {
      finalCents: discount.final_price_in_cents,
      originalCents: discount.original_price_in_cents,
      hasReferralDiscount: true,
      discountPercent: discount.discount_percent,
    };
  }

  return {
    finalCents: plan.price_in_cents,
    hasReferralDiscount: false,
    discountPercent: 0,
  };
};

export const formatPriceParts = (cents: number) => ({
  dollars: Math.floor(cents / 100),
  cents: (cents % 100).toString().padStart(2, '0'),
});
